var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterLinkedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M0.0959473 3.74234C0.0959473 2.97376 0.368127 2.33971 0.912462 1.84016C1.4568 1.34059 2.16446 1.09082 3.0354 1.09082C3.89081 1.09082 4.58288 1.33674 5.11168 1.82863C5.65601 2.33588 5.9282 2.99683 5.9282 3.81151C5.9282 4.54931 5.66381 5.16415 5.13501 5.65604C4.59068 6.16328 3.87524 6.41691 2.98874 6.41691H2.96542C2.11001 6.41691 1.41793 6.16328 0.889133 5.65604C0.360334 5.14879 0.0959473 4.51088 0.0959473 3.74234ZM0.399225 23.9169V8.51506H5.57826V23.9169H0.399225ZM8.44773 23.9169H13.6267V15.3168C13.6267 14.7788 13.689 14.3638 13.8134 14.0717C14.0311 13.5491 14.3616 13.1072 14.8049 12.746C15.2481 12.3848 15.8041 12.2041 16.4729 12.2041C18.2148 12.2041 19.0858 13.3647 19.0858 15.6856V23.9169H24.2648V15.0862C24.2648 12.8113 23.7204 11.0859 22.6317 9.90999C21.543 8.7341 20.1044 8.14615 18.3159 8.14615C16.3096 8.14615 14.7465 8.99925 13.6267 10.7054V10.7516H13.6035L13.6267 10.7054V8.51506H8.44773C8.47883 9.00693 8.49438 10.5363 8.49438 13.1033C8.49438 15.6703 8.47883 19.2749 8.44773 23.9169Z",
    fill: "#C7C7C7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLinkedIn);
export default __webpack_public_path__ + "static/media/footerLinkedIn.3be908508dee83a02c0c56f90aef3be3.svg";
export { ForwardRef as ReactComponent };